// @ts-check

import LightModal from '@flowio/light-modal';

let lightModal;

/**
 * @typedef ApiErrorResponse
 * @property {import('@flowio/types/dist/api').GenericError} error
 */
/**
 * @typedef OrderErrorResponse
 * @property {import('@flowio/types/dist/api').OrderError[]} errors
 * @property {import('@flowio/types/dist/api').Order} order
 */

 /** @typedef {OrderErrorResponse | ApiErrorResponse | Error} ModalParam */

export default function showErrorModal(/** @type {ModalParam} */ param) {
  if (lightModal == null) {
    lightModal = new LightModal();
  }

  if (param instanceof Error) {
    lightModal.render(param);
  } else if (/** @type {OrderErrorResponse} */ (param).errors) {
    const { errors } = /** @type {OrderErrorResponse} param */(param);
    const messageString = errors.map(error => `${error.code}: ${error.messages.join(', ')}`).join('\n');

    lightModal.render(new Error(messageString));
  } else if (/** @type {ApiErrorResponse} */ (param).error) {
    const { error } = /** @type {ApiErrorResponse} param */ (param);
    lightModal.render(new Error(`${error.code}: ${error.messages.join(', ')}`));
  } else if (param) {
    lightModal.render(new Error(`Unknown error: ${JSON.stringify(param)}`));
  }
}



// WEBPACK FOOTER //
// ./static/js/v0/utilities/error-modal.js